import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Box } from 'roo-ui/components';
import { useMount } from 'react-use';
import get from 'lodash/get';
import { useSelector } from 'react-redux';
import { getRoute } from 'store/router/routerSelectors';
import { SIMPLICITY_BUNDLE_URL } from 'config';

const SIMPLICITY_HEADER_DESKTOP_HEIGHT = '40px';
const SIMPLICITY_EXEMPT_PAGES = ['search-map', 'checkout'];

// We need to ensure that the script is not loaded again when the route changes
const isScriptAlreadyLoaded = () => !!document.querySelectorAll(`script[src="${SIMPLICITY_BUNDLE_URL}"]`).length;

const loadScript = () => {
  if (isScriptAlreadyLoaded()) return;
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = SIMPLICITY_BUNDLE_URL;
  document.head.appendChild(script);
};

// Simplicity CSS overrides are injected here
const SimplicityWrapper = styled(Box)`
  & .global_features_navigation {
    z-index: 0;
  }

  @media print {
    display: none;
  }
`;

const SimplicityHeader = React.memo(({ showMobileMenu }) => {
  const [content, setContent] = useState('');
  const route = useSelector(getRoute);
  const routeName = get(route, 'name', '');
  const classes = showMobileMenu ? { className: 'global_features_mobile' } : {};
  const hideSimplicityMenu = SIMPLICITY_EXEMPT_PAGES.includes(routeName);
  const isCypressEnvironment = typeof window !== 'undefined' && !!window.Cypress;

  useMount(() => {
    // Don't init in cypress cause simplicity wrecks havoc on the DOM, Simple!
    if (!isCypressEnvironment) {
      // Curly braces are escaped in SSR renders, so we add content after hydration
      setContent('{"environment": "production"}');
      loadScript();
    }
  });

  return (
    <SimplicityWrapper minHeight={SIMPLICITY_HEADER_DESKTOP_HEIGHT} hidden={hideSimplicityMenu}>
      <div {...classes} data-widget-type="global_features_navigation">
        <script type="qantas/widget">{content}</script>
      </div>
    </SimplicityWrapper>
  );
});

SimplicityHeader.displayName = 'SimplicityHeader';

SimplicityHeader.propTypes = {
  showMobileMenu: PropTypes.bool,
};

SimplicityHeader.defaultProps = {
  showMobileMenu: false,
};

export default SimplicityHeader;
